<template>
  <div class="page home">
    <div class="icon icon-logo abs"></div>
    <div class="icon icon-join abs"></div>
    <div class="footer-logo">
      <i class="icon icon-mg-logo"></i>
      <i class="icon icon-vip"></i>
    </div>
    <div class="icon icon-cat abs"></div>
    <div class="pannel-wrapper">
      <div class="pannel">
        <div class="icon icon-line1 abs"></div>
        <div class="icon icon-radar abs"></div>
        <div class="pannel-content">
          <p>亲爱的你现在走在哪，</p>
          <p>我有些悄悄话，</p>
          <p>想穿过夜色拥抱你啊。</p>
        </div>
      </div>
      <p class="pannel-tip">让我们说悄悄话说到沙哑……</p>
    </div>
    <div class="btn-wrapper">
      <div class="icon icon-paper abs"></div>
      <div class="btn" @click="onClickBtn('story')">故事招募</div>
      <div class="btn" @click="onClickBtn('mail')">信件招募</div>
      <div class="btn" @click="onClickBtn('reserve')">直播预约</div>
      <div class="btn" @click="linkBtn">全民共创</div>
      <div class="btn" @click="liveBtn">正在直播</div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    onClickBtn(target) {
      this.$router.push({ name: target });
    },
    linkBtn() {
      window.location.href = 'https://d.mgtv.com/a-oGmb'
    },
    liveBtn() {
      window.location.href = 'http://www.mgtv.com/z/1001086.html'
    },
  }
};
</script>

<style lang="scss">
@import "~@/assets/mixins.scss";
.home {
  .btn {
    &-wrapper {
      position: relative;
      @include px2vw(width, 187);
      margin: 0 auto;
    }
    background-image: url("~@/assets/img/btn.png");
    &.disabled {
      background-image: url("~@/assets/img/btn-dis.png");
    }
    @include px2vw(width, 187);
    @include px2vw(height, 81);
    @include px2vw(line-height, 81);
    @include px2vw(font-size, 35);
    font-weight: bold;
    & + .btn {
      @include px2vw(margin-top, 30);
    }
  }
  .pannel {
    &-wrapper {
      @include px2vw(padding-top, 195);
      @include px2vw(font-size, 24);
      @include px2vw(line-height, 40);
      color: #333333;
    }
    &-tip {
      @include px2vw(padding-top, 50);
      @include px2vw(padding-bottom, 75);
      font-weight: 400;
      letter-spacing: 2px;
      text-align: center;
    }
    &-content {
      font-weight: 600;
    }
    position: relative;
    background-image: url("~@/assets/img/panel-tip.png");
    @include px2vw(width, 620);
    @include px2vw(height, 275);
    @include px2vw(padding-left, 295);
    @include px2vw(padding-top, 78);
    margin: 0 auto;
  }

  .icon {
    &-radar {
      @include px2vw(top, 0);
      @include px2vw(right, 27);
      transform: translateY(-100%);
    }
    &-line1 {
      @include px2vw(bottom, 0);
      @include px2vw(right, 27);
      transform: translateY(100%);
    }
    &-logo {
      @include px2vw(top, 20);
      @include px2vw(left, 30);
    }
    &-join {
      @include px2vw(bottom, 0);
      left: 0;
    }
    &-cat {
      @include px2vw(bottom, 203);
      @include px2vw(right, 30);
    }
    &-paper {
      @include px2vw(top, -30);
      @include px2vw(left, -75);
      transform: translateX(-100%);
    }
  }
}
</style>
